import { styled, css } from '../../../../modules';

export const PageWrapper = styled.div<{ $background: string }>`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
    max-width: calc(100vh * 3 / 4);
    background-color: ${({ $background }) => $background};
    position: relative;
`;

const spin = css`
    @keyframes spin {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
    }
`;

export const SpinnerWrapper = styled.div<{ $hasLogo: boolean }>`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${({ $hasLogo }) => ($hasLogo ? '160px' : '96px')};
    height: ${({ $hasLogo }) => ($hasLogo ? '160px' : '96px')};
`;

export const Spinner = styled.div<{ $color: string; $hasLogo: boolean; $spinDelayMs: number }>`
    ${spin}
    position: absolute;
    width: ${({ $hasLogo }) => ($hasLogo ? '160px' : '96px')};
    height: ${({ $hasLogo }) => ($hasLogo ? '160px' : '96px')};
    border-radius: 50%;
    border: ${({ $hasLogo }) => ($hasLogo ? '8px' : '5px')} solid ${({ $color }) => `${$color}33`};
    border-top-color: ${({ $color }) => $color};
    animation: spin 1s linear infinite;
    animation-delay: ${({ $spinDelayMs }) => $spinDelayMs}ms;
`;

export const LogoImage = styled.img`
    width: 64px;
    height: 64px;
    object-fit: contain;
    border-radius: 12px;
`;

export const PoweredByContainer = styled.div`
    position: absolute;
    bottom: 24px;
    display: flex;
    align-items: center;
    gap: 6px;
`;

export const PoweredByText = styled.span`
    font-size: 11px;
    color: rgba(255, 255, 255, 0.7);
    font-style: italic;
`;

export const PoweredByBrand = styled.span`
    font-size: 11px;
    color: rgba(255, 255, 255, 0.7);
    margin-left: -2px;
`;
